import { Box, CircularProgress } from '@mui/material';
import DropdownSelect from '../../components/DropdownSelect';
import ToastMessage from '../../components/ToastMessage';
import {
  RoundedButton,
  SearchInputWrapper,
  SectionContainerWrapper
} from './styled';
import RolloverRemark from './components/scheme/RolloverRemark';
import AdmissionTypeTab from './components/AdmissionTypeTab';
import Icons from '../../components/icons';
import PaymentOptionSection from './components/scheme/PaymentOptionSectionForm';
import FeeStructureProvider, {
  useFeeStructureContext
} from './context/FeeStructureContext';
import { useSchoolClassesConfigHook } from '../common/hooks/useSchoolClassesConfig';
import { getUniqueGrades } from '../../utils/gradeUtils';
import { ButtonContainer } from '../Staff/styled';
import { Title } from '../common/styled';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { superAdminUsers } from '../../constants/superAdminUsers';

const FeeStructurePage = () => {
  const { schoolClassesConfig, loggedInUser } = useSchoolClassesConfigHook();

  return (
    <FeeStructureProvider loggedInUser={loggedInUser}>
      <FeeStructureContent gradeOptions={schoolClassesConfig?.grades} />
    </FeeStructureProvider>
  );
};

const FeeStructureContent = ({ gradeOptions }: { gradeOptions: [] }) => {
  const {
    selectedAcademicYear,
    setSelectedAcademicYear,
    selectedGrade,
    setSelectedGrade,
    academicYears,
    hasSearched,
    isSearching,
    handleSearch,
    admissionType,
    setAdmissionType,
    toastOpen,
    toastMessage,
    toastSeverity,
    handleCloseToast,
    setHasSearched
  } = useFeeStructureContext();

  const uniqueGrades = getUniqueGrades(gradeOptions);
  const filteredGrades = uniqueGrades.map((grade) => ({
    label: grade,
    value: grade
  }));

  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );

  return (
    <Box>
      <Title>Payment Scheme Master</Title>
      <SectionContainerWrapper>
        <SearchInputWrapper>
          <DropdownSelect
            label='Academic Year'
            placeholder='Select Academic Year'
            name='academicYear'
            value={selectedAcademicYear}
            options={academicYears}
            onChange={(event) => {
              setSelectedAcademicYear(event.target.value as string);
              setHasSearched(false);
            }}
            hasTopLabel
          />
          <DropdownSelect
            label='Grade'
            name='grade'
            value={selectedGrade}
            options={filteredGrades}
            onChange={(event) => {
              setSelectedGrade(event.target.value as string);
              setHasSearched(false);
            }}
            placeholder='Select Grade'
            hasTopLabel
            disabled={!superAdminUsers.includes(loggedInUser?.email)}
          />
          <ButtonContainer>
            <RoundedButton
              onClick={handleSearch}
              disabled={
                !superAdminUsers.includes(loggedInUser?.email) ||
                isSearching ||
                !selectedGrade
              }
              variant='contained'
            >
              <Icons.SearchWhiteOutlined style={{ marginRight: '6px' }} />
              {isSearching ? (
                <CircularProgress size={24} color='inherit' />
              ) : (
                'Search'
              )}
            </RoundedButton>
          </ButtonContainer>
        </SearchInputWrapper>
      </SectionContainerWrapper>
      {hasSearched && (
        <>
          <AdmissionTypeTab
            admissionType={admissionType}
            setAdmissionType={setAdmissionType}
          />
          <PaymentOptionSection />
          <RolloverRemark />
        </>
      )}
      <ToastMessage
        open={toastOpen}
        message={toastMessage}
        severity={toastSeverity}
        onClose={handleCloseToast}
      />
    </Box>
  );
};

export default FeeStructurePage;
